import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Icon } from "@iconify/react";
import trayUpload from "@iconify/icons-mdi/tray-upload";
import '../../../styles/Auth/profile.css'
import { getData, putData, uploadFile } from '../../../webService/webservice.js';

const ProfilePage = () => {
    const navigate = useNavigate();
    const [previewUrl, setPreviewUrl] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [formData, setFormData] = useState(
        {
            name: "",
            email: "",
            phoneNumber: "",
        }
    );
    const validateEmail = (email) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormData((prev) => ({ ...prev, email }));

        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem("Token");
                const userId = localStorage.getItem("userId");
                const response = await getData(`users/user/${userId}`, token);
                const user = response?.data;

                setFormData({
                    name: user?.name || "",
                    email: user?.email || "",
                    phoneNumber: user?.phoneNumber || "",
                });
                if (user?.employeeImageObject?.uri) {
                    setPreviewUrl(`${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`);
                } else {
                    setPreviewUrl("/assets/mdi--user.svg");
                }
            } catch (err) {
                console.error("Failed to fetch user details:", err);
            }
        };

        fetchUser();
    }, []);
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = formData.employeeImageObject;

            if (profileImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, profileImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }
            const updatedEmployeeData = {
                name: formData.name,
                email: formData.email,
                phoneNumber: formData.phoneNumber,
                employeeImageObject: updatedImageObject,
            };

            console.log("Updating Employee with data:", updatedEmployeeData);

            const response = await putData(`users/user/${userId}`, updatedEmployeeData, token);

            toast.success(response.message || 'Employee updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                name: '',
                email: '',
                phoneNumber: '',
                employeeImageObject: ''
            });
            setProfileImage(null);
            setPreviewUrl(null);
            navigate('/dashboard');
        } catch (err) {
            console.error("Error updating profile:", err);
            alert("Failed to update profile");
        }
    };
    return (
        <>
            <div className="profile-layout">
                <div className="profile-content">
                    <main className="profile-main">
                        <div className="update-profile-form">
                            <h3>Profile</h3>
                            <form className='profile-form'>
                                <div className='profile-form-row'>
                                    <div className="profile-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="profileImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="profileImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.size > 1024 * 1024) {
                                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                            e.target.value = "";
                                                            return;
                                                        }
                                                        setProfileImage(file);
                                                        setPreviewUrl(URL.createObjectURL(file));
                                                    }}
                                                />

                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='profile-form-row'>
                                    <div className='profile-form-group'>
                                        <label htmlFor="name" className="input-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter  name"
                                            className="category-input"
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className='profile-form-group'>
                                        <label htmlFor="email" className="input-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="category-input"
                                            placeholder="Enter Email"
                                            value={formData.email || ""}
                                            onChange={handleEmailChange}
                                        />
                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                    </div>
                                    <div className='profile-form-group'>
                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Mobile Number"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.phoneNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                            onBlur={() => {
                                                if (formData.phoneNumber.length !== 10) {
                                                    alert("Mobile Number must be exactly 10 digits");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="Profile-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleUpdateProfile}>
                                        Save Changes
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/dashboard')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default ProfilePage;